import React from 'react';
import { Dialog as MuiDialog, DialogContent } from '@mui/material';
import styled from 'styled-components';
import Colors from '../global/Colors';
import Fonts from '../global/Fonts';
import Button from './Button';

interface StyledDialogContentProps {
  $width?: string;
  $height?: string;
  $colorMode: 'light' | 'dark';
  $fullscreen: boolean;
}

const StyledDialogContent = styled(DialogContent)<StyledDialogContentProps>`
  position: relative;
  width: ${props => props.$fullscreen ? 'calc(100vw - 20px)' : props.$width || 'auto'};
  height: ${props => props.$fullscreen ? 'calc(100vh - 20px)' : props.$height || 'auto'};
  max-width: ${props => props.$fullscreen ? 'calc(100vw - 20px)' : 'calc(100vw - 20px)'};
  max-height: ${props => props.$fullscreen ? 'calc(100vh - 20px)' : 'calc(100vh - 20px)'};
  background-color: ${props => props.$colorMode === 'light' ? Colors.background : Colors.grey9};
  color: ${props => props.$colorMode === 'light' ? Colors.black : Colors.white};
  font-family: ${Fonts.lexendMedium.fontFamily};
  font-weight: ${Fonts.lexendMedium.fontWeight};
  padding: 5px;
  border-radius: 14px;
  border: 1px solid ${props => props.$colorMode === 'light' ? Colors.grey2 : Colors.grey8};
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;

const CloseButtonWrapper = styled.div`
  position: absolute;
  top: 12px;
  right: 12px;
  opacity: 0.4;
  z-index: 1;

  @media (max-width: 768px) {
    top: 10px;
    right: 10px;
  }
`;

interface ModalProps {
  colorMode?: 'light' | 'dark';
  width?: string;
  height?: string;
  content: React.ReactNode;
  isOpen: boolean;
  onClose: () => void;
  includeCloseButton?: boolean;
  fullscreen?: boolean;
}

const Modal: React.FC<ModalProps> = ({
  colorMode = 'dark',
  width,
  height,
  content,
  isOpen,
  onClose,
  includeCloseButton = true,
  fullscreen = false
}) => {
  return (
    <MuiDialog
      open={isOpen}
      onClose={onClose}
      onClick={(e) => e.stopPropagation()}
      PaperProps={{
        style: {
          backgroundColor: 'transparent',
          boxShadow: 'none',
          margin: 0,
          padding: 0,
          maxWidth: 'none',
          maxHeight: 'none',
        }
      }}
      BackdropProps={{
        style: {
          backgroundColor: 'rgba(0, 0, 0, 0.6)'
        }
      }}
    >
      <StyledDialogContent 
        $width={width} 
        $height={height} 
        $colorMode={colorMode}
        $fullscreen={fullscreen}
      >
        {includeCloseButton && (
          <CloseButtonWrapper>
            <Button
              icon="delete"
              onClick={onClose}
              color={colorMode === 'light' ? 'ghost' : 'ghost white'}
              size="micro"
            />
          </CloseButtonWrapper>
        )}
        {content}
      </StyledDialogContent>
    </MuiDialog>
  );
};

export default Modal;